module.exports = __webpack_public_path__ + "static/media/exchange.5a65f88f.svg";